/**
 * Removes an item from an array at the specified index (in-place)
 */
export const removeFromArrayInPlace = (arr: unknown[], index: number) => {
  arr.splice(index, 1);
};

/**
 * Reorders an array by moving an item from sourceIndex to targetIndex (in-place)
 */
export const reorderArrayInPlace = (arr: unknown[], sourceIndex: number, targetIndex: number) => {
  arr.splice(targetIndex, 0, arr.splice(sourceIndex, 1)[0]);
};
